<div class="row mb-2">
  <div class="col-12">
    <h3>Provider Data Reviews</h3>

    <form [formGroup]="formGroup" novalidate>
      <div class="container-fluid p-2 border bg-light mb-2">
        <div class="row">
          <div class="col-3 pe-1">
            <div class="mb-3" formGroupName="filters">
              <label>
                <strong>Review Type:</strong>
              </label>
              <ng-select
                class="w-100"
                name="reviewType"
                bindValue="value"
                bindLabel="display"
                [multiple]="true"
                [items]="typeOptions"
                [clearable]="true"
                [searchable]="false"
                placeholder="Filter by Type"
                formControlName="reviewType" />
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3">
              <label>
                <strong>Sort By:</strong>
              </label>
              <ng-select
                class="w-100"
                name="sortBy"
                bindValue="value"
                bindLabel="display"
                [multiple]="false"
                [items]="sortByOptions"
                [clearable]="false"
                [searchable]="false"
                formControlName="sort" />
            </div>
          </div>

          <div class="col-3">
            <div class="mb-3" formGroupName="filters">
              <label>
                <strong>Assigned User:</strong>
              </label>
              <ng-select
                bindValue="id"
                bindLabel="fullName"
                name="assignedToIds"
                placeholder="Filter by Assigned Users"
                [items]="assignedToUsers"
                [clearable]="true"
                [searchable]="false"
                [multiple]="true"
                formControlName="assignedToIds"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

@if (!loading) {
  @if (showPaginationHeader) {
    <app-pagination-header
      [paging]="paging"
      [label]="'reviews'"
      (pageSizeChange)="onPageSizeChange($event)"
      [includeResetFiltersButton]="true"
      (resetFiltersClick)="onResetFiltersClick()" />
  }
  @if (dataReviews.length > 0) {
    <app-provider-data-review-list
      [dataReviews]="dataReviews"
      [selectedDataReviewIds]="selectedDataReviewIds"
      [totalCount]="paging.count"
      (providerDataReviewSelected)="onProviderDataReviewSelected($event)"
      (providerDataReviewDeselected)="onProviderDataReviewDeselected($event)"
      (assignmentUpdate)="onAssignmentUpdate($event)"
      (assignmentClearSelection)="onAssignmentClearSelection()"
    />
    <div class="mt-2">
      <app-pagination [paging]="paging" (pageChange)="onPageChange()" />
    </div>
  } @else {
    <p class="ms-1">No provider data reviews requiring review.</p>
  }
} @else {
  <div class="ms-1"><mat-spinner diameter="30" /></div>
}